// The relative-date token a generated app writes into its starting rows, and the one
// thing the gate and the publisher must agree on exactly.
//
// It lived in `saddleHost.ts`, which is the CLIENT publish orchestration and imports the
// project store and Cognito with it. The gate imported this one regex from there and
// inherited all of it — so the gate, which is pure and belongs anywhere, could only run
// where a signed-in app could. One regex was holding the whole pipeline in the client.

/**
 * The token grammar: an offset, then optionally a weekday, then optionally a time.
 *
 * The weekday part exists because the apps that need relative dates most are the ones
 * anchored to a day of the week — a wedding weekend is Friday drinks, Saturday ceremony,
 * Sunday brunch, and a supper club runs on Saturdays. Without it a generated wedding page
 * invented `'+2w 5fri 18:00'`, which parsed as nothing: publish passed the string through
 * untouched, `S.fmt.date` returned '' for it, and all three events rendered as a lone
 * separator where their date should have been.
 */
export const DATE_TOKEN = /^\+(\d{1,3})([dwh])(?:\s+(mon|tue|wed|thu|fri|sat|sun))?(?:\s+(\d{1,2}):(\d{2}))?$/i;
